import { useState } from "react";
import { useGuestCountPrompt } from "./useGuestCountPrompt";

/**
 * „Брой гости" преди „Нова маса" (настройка „Въвеждане на брой гости" = при
 * нова маса). `askBeforeNewTable` се вика първо в „Нова маса": `false` =
 * „Отказ" и потокът спира (нито модалът за името, нито бързото отваряне).
 * Броят чака в `newTableGuests` и пътува с `POST /bills` (`guests`) при
 * „Поръчай" на новата маса. Изваден от Ordering.tsx.
 */
export const useNewTableGuests = () => {
  const { askFor, askGuestCount, guestCountModal, guestCountModalOpen } =
    useGuestCountPrompt();
  const [newTableGuests, setNewTableGuests] = useState<number | null>(null);

  const askBeforeNewTable = async (): Promise<boolean> => {
    if (!askFor("new_table")) {
      setNewTableGuests(null);
      return true;
    }
    const guests = await askGuestCount();
    if (guests == null) return false;
    setNewTableGuests(guests);
    return true;
  };

  return {
    newTableGuests,
    askBeforeNewTable,
    guestCountModal,
    guestCountModalOpen,
  };
};
